module.exports = __webpack_public_path__ + "img/swipe.4fd0f4be.png";